// Copyright © 2020 BREAS. All rights reserved

import {
  Logger as MsaLogger,
  LogLevel,
  UserAgentApplication
} from "msal";
import createAppConfig from '../../utils/app-config';

const AppConfig = createAppConfig();

const AuthConfig = {
    options: {      
      // For more information about "Application configuration options", please see:
      // https://learn.microsoft.com/en-us/azure/active-directory/develop/msal-client-application-configuration#authority
      // https://learn.microsoft.com/en-us/azure/active-directory/develop/authentication-national-cloud#azure-ad-authentication-endpoints
      authority: `${AppConfig.Authority}${AppConfig.TenantId}`,
      clientId: AppConfig.AppId,
      postLogoutRedirectUri: `${AppConfig.PublicUrl}/view-server/auth/signout`,
      redirectUri: `${AppConfig.PublicUrl}/view-server/auth/signin`,
      validateAuthority: false,
  },
  scopes: ['openid'],
}

const msalConfig = {
  auth: {
      ...AuthConfig.options,
      navigateToLoginRequestUrl: false
  },
  cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: true, // BrowserUtil.isIE(),
  },
  system: {
      navigateFrameWait: 500,
      logger: new MsaLogger((logLevel, message) => {
          console.trace(message);
      }, {
          level: LogLevel.Verbose,
          piiLoggingEnabled: true
      }),
      telemetry: {
          applicationName: "breas-everyware",
          applicationVersion: AppConfig.AppVersion,
          telemetryEmitter: (events) => {
            console.trace('Telemetry Events:', events);
          }
      }
  }
};

const msalApp = new UserAgentApplication(msalConfig);
const tokenRequestScopes = { scopes: AuthConfig.scopes };

export class AuthService {
    getAccessTokenAsync = async () => {
      try {
          return await msalApp.acquireTokenSilent({
              ...tokenRequestScopes,
              sid: msalApp.getAccount()?.accountIdentifier
              // forceRefresh: true,
          });
      } catch (err) {
          if (this.RequiresInteraction(err.errorCode)) {
              msalApp.acquireTokenRedirect({
                  ...tokenRequestScopes,
                  forceRefresh: true,
                  redirectUri: AuthConfig.options.redirectUri
              });
          } else {
            console.error(`Non-interactive error: ${err}`);
            throw err;
          }
      }
  }

  getUserAsync = async () => {
      const response = await this.getAccessTokenAsync();
      if (!response || !response.accessToken) {
          window.location.href = '/authentication/signin';
          return null;
      }
      const account = msalApp.getAccount();
      return account;
  }

  login = () => {
      msalApp.loginRedirect({
          ...tokenRequestScopes,
          prompt: 'select_account',
          forceRefresh: true,
          redirectUri: AuthConfig.options.redirectUri,
          redirectStartPage: AuthConfig.options.redirectUri,
          state: AppConfig.PublicUrl,
      });
  }

  logout = () => {
      msalApp.logout();
  }

  RequiresInteraction = (errorMsg) => {
      if (!errorMsg || !errorMsg.length)
          return false;

      return (
          errorMsg.indexOf('consent_required') > -1 ||
          errorMsg.indexOf('interaction_required') > -1 ||
          errorMsg.indexOf('login_required') > -1 ||
          errorMsg.indexOf('user_login_error') > -1 ||
          errorMsg.indexOf('sso_silent_error') > -1
      );
  }
}
